import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

elabs.Slideshow = class {
  constructor(element) {
    this.view = element;

    const swiperElement = this.view.querySelector('.swiper');
    let autoPlaySpeed = 999999;
    const autoplayEnabled = this.view.getAttribute('data-autoplay-enabled') === 'true';
    if (autoplayEnabled) {
      autoPlaySpeed = parseInt(this.view.getAttribute('data-autoplay-speed'), 10) || autoPlaySpeed;
    }

    const isSingleSlideSwiper = this.view.querySelectorAll('.swiper-slide').length <= 1;

    this.swiperSlider = new Swiper(swiperElement, {
      modules: [EffectFade, Autoplay],
      enabled: !isSingleSlideSwiper,
      autoHeight: true,
      speed: 1000, // the length of transition between slides
      autoplay: {
        delay: Shopify.designMode === true ? 999999 : autoPlaySpeed, // the length each slide shows for. Don't auto play in the theme editor
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: isSingleSlideSwiper ? false : true,
      controller: {
        control: null,
      },
      on: {
        realIndexChange: (/*swiperSlider*/) => {
          //this.onIndexChanged(swiperSlider.realIndex);
        },
      },
    });

    this.wireEvents();
  }

  wireEvents = () => {
    // Add any event listeners if needed
    const nextButton = this.view.querySelector('.el-slideshow__nav-button--next');
    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.swiperSlider.slideNext();
      });
    }
    const prevButton = this.view.querySelector('.el-slideshow__nav-button--prev');
    if (prevButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.swiperSlider.slidePrev();
      });
    }
  };
};

elabs.onJavascriptReady(() => {
  document.querySelectorAll('.el-slideshow').forEach((element) => {
    void new elabs.Slideshow(element);
  });
});
